/* @ngInject */
function RouterResolver() {
    this.firstLoad = function (source) {
        return {
            deps: [
                'CONST',
                '$q',
                'User',
                'Club',
                '$state',
                '$timeout',
                'Backoffice',
                'SessionSync',
                '$rootScope',
                function (CONST, $q, User, Club, $state, $timeout, Backoffice, SessionSync, $rootScope) {
                    const deferred = $q.defer();

                    if (CONST._loaded) {
                        resolve();
                        return deferred.promise;
                    }

                    CONST.$info({
                        user: source !== 'login',
                    })
                        .then(resolve)
                        .catch(() => {
                            if (source === 'app') {
                                clearBrokenSessionState();
                                $timeout(() => $state.go('login.signin'), 100);
                            }

                            deferred.reject();
                        });

                    function resolve() {
                        if (!User.loggedIn && source === 'app') {
                            Backoffice.token_manager.forget();
                            deferred.reject();

                            $timeout(() => $state.go('login.signin'), 100);
                        } else if (source === 'login') {
                            if (User.loggedIn) {
                                deferred.reject();
                                const hasFeatureEnabled =
                                    Club.hasNewBookingsCalendarEnabled();
                                if (hasFeatureEnabled) {
                                    $timeout(() => $state.go('app.grid'), 100);
                                    return;
                                }

                                $timeout(() => $state.go('app.bookings'), 100);
                                return;
                            }
                            if (!User.loggedIn) {
                                Backoffice.token_manager.forget();
                                deferred.resolve();
                                return;
                            }
                        } else {
                            deferred.resolve();
                        }
                    }

                    function clearBrokenSessionState() {
                        User.API.one('logout').post().catch(() => {});

                        const cookies = document.cookie
                            ? document.cookie.split(';')
                            : [];

                        cookies.forEach((cookie) => {
                            const name = cookie.split('=')[0].trim();
                            if (
                                name === 'session' ||
                                name.startsWith('remember_club_')
                            ) {
                                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
                            }
                        });

                        Backoffice.token_manager.forget();
                        Backoffice.intercom.logOut();
                        localStorage.removeItem('api_v3_token');
                        localStorage.removeItem('api_v3_refresh_token');
                        localStorage.removeItem('session_last');

                        SessionSync.broadcastLogout();
                        User.logout();
                        $rootScope.$broadcast('session:logout:cleanup');
                    }
                    return deferred.promise;
                },
            ],
        };
    };

    this.$get = () => ({
        firstLoad: this.firstLoad,
    });
}

export default RouterResolver;
